import { render, staticRenderFns } from "./ParticipantInjured.vue?vue&type=template&id=c3c07e96"
import script from "./ParticipantInjured.vue?vue&type=script&lang=js"
export * from "./ParticipantInjured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports